import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quote-request-content" }
const _hoisted_2 = { class: "quote-request-price-container" }
const _hoisted_3 = { class: "quote-request-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "quote-request-wr",
    onClick: $setup.toggleSummaryModal
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "quote-request-text" }, "Subtotal", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($props.totalPrice), 1)
      ])
    ])
  ]))
}